import type React from "react";

import { useFeatureFlags } from "hooks/useFeatureFlags";

import { Footer } from "components/Footer";

import { StyledPageLayout } from "./MainPageLayout.styled";

interface MainPageLayoutProps {
  children: React.ReactNode;
  className?: string;
  header: React.ReactNode;
  navigationMenu: React.ReactNode;
  shouldShowHeader: boolean;
  shouldShowSideNav: boolean;
}

export const MainPageLayout: React.FC<MainPageLayoutProps> = ({
  children: content,
  className,
  header,
  navigationMenu,
  shouldShowHeader = false,
  shouldShowSideNav = false,
}) => {
  const { enableUxImprovements } = useFeatureFlags();

  return (
    <StyledPageLayout
      className={className}
      $centerContent={!!enableUxImprovements}
      $hasHeader={shouldShowHeader}
      $hasSideMenu={shouldShowSideNav}
    >
      {shouldShowHeader && header}
      {shouldShowSideNav && navigationMenu}
      <main>{content}</main>
      <Footer />
    </StyledPageLayout>
  );
};
